// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'layout-detached';

export const Component = () => (
  <g fill='#D0E0F7' stroke='#4185DE' strokeLinecap='round' strokeLinejoin='round'>
    <rect width='17' height='5' x='.5' y='.5' rx='.5' />
    <rect width='5' height='9' x='.5' y='8.5' rx='.5' />
    <rect width='9' height='9' x='8.5' y='8.5' rx='.5' />
  </g>
);

export const viewBox = '0 0 18 18';
